

import isNil from 'lodash.isnil';
import { DATE_FORMAT, formatDate } from '@shootsta/get-moment';
import { sortDate, sortNumber, sortText } from '@shootsta/sort';

import { DATA_TABLE_ALIGN_HORIZONTAL } from '../dataTableAlignHorizontal';
import { DATA_TABLE_COLUMN_FIELD } from './dataTableColumnField';


export const DATA_TABLE_ID_COLUMN_GET_VALUE = (
rawValue) =>
`${rawValue.split('-')[0]}`;
export const DATA_TABLE_ID_COLUMN_GET_VALUE_COMPARATOR = sortText;
export const DATA_TABLE_ID_COLUMN_OPTIONS = {
  header: '#ID',
  getValue: DATA_TABLE_ID_COLUMN_GET_VALUE,
  getValueComparator: DATA_TABLE_ID_COLUMN_GET_VALUE_COMPARATOR
};

export const DATA_TABLE_TEXT_COLUMN_GET_VALUE_COMPARATOR = sortText;
export const DATA_TABLE_TEXT_COLUMN_OPTIONS = {
  alignHorizontal: DATA_TABLE_ALIGN_HORIZONTAL.START,
  getValueComparator: DATA_TABLE_TEXT_COLUMN_GET_VALUE_COMPARATOR
};

export const DATA_TABLE_NUMBER_COLUMN_GET_VALUE_COMPARATOR = sortNumber;
export const DATA_TABLE_NUMBER_COLUMN_OPTIONS = {
  alignHorizontal: DATA_TABLE_ALIGN_HORIZONTAL.END,
  getValueComparator: DATA_TABLE_NUMBER_COLUMN_GET_VALUE_COMPARATOR
};

export const DATA_TABLE_PERCENTAGE_COLUMN_GET_VALUE_COMPARATOR = sortNumber;
export const DATA_TABLE_PERCENTAGE_COLUMN_GET_VALUE = (
rawValue) =>

isNil(rawValue) ? null : `${rawValue.toString()}%`;
export const DATA_TABLE_PERCENTAGE_COLUMN_OPTIONS = {
  alignHorizontal: DATA_TABLE_ALIGN_HORIZONTAL.END,
  getValueComparator: DATA_TABLE_PERCENTAGE_COLUMN_GET_VALUE_COMPARATOR,
  getValue: DATA_TABLE_PERCENTAGE_COLUMN_GET_VALUE
};

export const DATA_TABLE_DATE_COLUMN_GET_VALUE_COMPARATOR = sortDate;
export const DATA_TABLE_DATE_COLUMN_GET_VALUE = (
rawValue) =>
rawValue ? formatDate(rawValue, DATE_FORMAT.MONTH_SHORT_DAY_YEAR) : null;
export const DATA_TABLE_DATE_COLUMN_OPTIONS = {
  alignHorizontal: DATA_TABLE_ALIGN_HORIZONTAL.CENTER,
  getValueComparator: DATA_TABLE_DATE_COLUMN_GET_VALUE_COMPARATOR,
  getValue: DATA_TABLE_DATE_COLUMN_GET_VALUE
};

export const DATA_TABLE_EXPANDER_WITH_DATA_COLUMN_OPTIONS_GET_VALUE = () => '';
export const DATA_TABLE_EXPANDER_WITH_DATA_COLUMN_OPTIONS = {
  field: DATA_TABLE_COLUMN_FIELD.EXPAND_WTH_DATA,
  getValue: DATA_TABLE_EXPANDER_WITH_DATA_COLUMN_OPTIONS_GET_VALUE
};